export enum SortDirection {
  ASC,
  DESC
}

export const sortDirectionMap: Map<SortDirection, string> = new Map([
  [SortDirection.ASC, "asc"],
  [SortDirection.DESC, "desc"]
]);
